const nodeToText = (node: Node): string => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent || "";
  }

  if (node.nodeType !== Node.ELEMENT_NODE) return "";

  const element = node as Element;
  const tagName = element.tagName.toLowerCase();
  const childrenText = (): string => Array.from(element.childNodes).map(nodeToText).join("");

  if (tagName === "br") return "\n";
  if (tagName === "strong" || tagName === "b") return `**${childrenText()}**`;
  if (tagName === "em" || tagName === "i") return `_${childrenText()}_`;
  if (tagName === "a") {
    const href = element.getAttribute("href") || "";
    const text = childrenText();
    // If the link text matches the href, it was auto-linked — keep as plain text.
    // Only preserve markdown link syntax for intentional links (text !== href).
    if (!href || text === href || text === href.replace(/\/$/, "")) {
      return text;
    }
    return `[${text}](${href})`;
  }
  if (element.classList.contains("mention")) {
    const mentionId = element.getAttribute("data-id") || element.textContent || "";
    return `@${mentionId}`;
  }

  return childrenText();
};

export const extractTextFromHtml = (html: string): string => {
  const container = document.createElement("div");
  container.innerHTML = html;

  return Array.from(container.childNodes).map(nodeToText).join("\n").trim();
};
